import React from 'react';
import { Navigate } from 'react-router-dom';
import { isFullAdmin, isSuperAdmin, normalizeRole } from '../utils/auth';

const ROLE_ACCESS = {
  admin: ['admin', 'super_admin'],
  staff: ['admin', 'super_admin', 'staff', 'branch_manager', 'branch_staff', 'technician', 'cashier', 'manager'],
  branch_manager: ['admin', 'super_admin', 'branch_manager', 'manager'],
  technician: ['admin', 'super_admin', 'branch_manager', 'manager', 'technician']
};

const ProtectedRoute = ({
  children,
  requiredRole = 'all',
  requiredPermission = null,
  allowedRoles = null
}) => {
  const isAuthenticated = localStorage.getItem('erp_auth_token');
  const userRole = normalizeRole(localStorage.getItem('erp_user_role') || 'staff');

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isSuperAdmin()) {
    return children;
  }

  // When allowedRoles is set, only those roles (plus super_admin above) may access
  if (Array.isArray(allowedRoles)) {
    if (!allowedRoles.map(normalizeRole).includes(userRole)) {
      return <Navigate to="/dashboard" replace />;
    }
    return children;
  }

  // Permission keys used by App.js — treat repairs/pos/etc as open to authenticated users
  // with finer checks done in pages / Layout. Admin-only pages use allowedRoles.
  if (requiredPermission) {
    if (requiredPermission === 'users' || requiredPermission === 'branches' || requiredPermission === 'branch_users') {
      if (!isFullAdmin()) return <Navigate to="/dashboard" replace />;
    }
    if (requiredPermission === 'login_history') {
      return <Navigate to="/dashboard" replace />;
    }
    return children;
  }

  if (requiredRole !== 'all') {
    if (requiredRole === 'admin' && isFullAdmin()) {
      return children;
    }
    const allowed = ROLE_ACCESS[requiredRole] || [requiredRole];
    if (!allowed.map(normalizeRole).includes(userRole)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
